import { render, staticRenderFns } from "./VerticalNavMenuHeader.vue?vue&type=template&id=15d2f16b&scoped=true"
import script from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuHeader.vue?vue&type=script&lang=js"
import style0 from "./VerticalNavMenuHeader.vue?vue&type=style&index=0&id=15d2f16b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d2f16b",
  null
  
)

export default component.exports